import { Link, useNavigate } from "react-router-dom";
import { Activity, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Logo = ({ to = "/" }) => (
  <Link to={to} className="flex items-center gap-2" data-testid="brand-logo">
    <span className="flex h-8 w-8 items-center justify-center rounded-md bg-[#CCFF00] text-[#0B0F17]">
      <Activity className="h-5 w-5" strokeWidth={2.75} />
    </span>
    <span className="font-display text-2xl font-black uppercase tracking-tight text-white">
      Sports<span className="text-[#CCFF00]">Diary</span>
    </span>
  </Link>
);

export const TopBar = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#0B0F17]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-8">
        <Logo />
        <div className="flex items-center gap-3">
          {children}
          {user && (
            <>
              <span className="hidden text-sm text-slate-400 md:inline" data-testid="topbar-user-email">{user.email}</span>
              <button
                data-testid="logout-btn"
                onClick={async () => { await logout(); nav("/login"); }}
                className="inline-flex items-center gap-1.5 rounded-md border border-white/10 px-3 py-1.5 text-xs font-semibold text-slate-300 transition-colors hover:border-white/30 hover:text-white"
              >
                <LogOut className="h-3.5 w-3.5" /> Log out
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
